module.exports = __webpack_public_path__ + "media/images/join-kumu-footer-44d8edb5ec5688a1cdf5a1618d5f5766.jpg";